<template>
  <div id="done-paper">
    <p>オーダーNo.
      <Loading v-if="loading" :is_loading="loading"></Loading>
      <span v-else>{{cart_number}}</span>
    </p>

    <p>ご注文ありがとうございます。<br>
      入力いただいたメールアドレスに確認メールをお送りしましたので、ご確認ください。
    </p>
    <p>メールに記載されている色・サイズ、枚数で作業の方を進めさせていただきます。<br>
    注意書きに記載されて頂いている通り、商品の出来上がりまでは1ヶ月〜1ヶ月半程度のお時間いただいております。<br>
    今後のキャンセルは受け付けられません。また、イメージと違った・サイズが合わない等でのクレーム・交換も受け付けられませんので、ご了承ください。
    </p>
    <p v-if="order.payment_method==='bank'">
      アレンジ等をご希望の方には、こちらから1度ご連絡させていただきます。<br>
      「info@chapeu.co.jp」「info@chapeu.ciao.jp」からのメールを、受信できるように設定をお願い致します。
    </p>
    <p v-if="order.payment_method==='bank'">
      「お支払いについて」<br>
      商品と一緒に請求書を送付させて頂きます。<br>
      商品がお手元に届き、ご確認頂いた後、2週間以内に請求書に掲載されている、銀行口座にお振込ください。<br>
      ※期日までにお振込が確認できない場合、法的な手続きをさせて頂く場合がございます。
    </p>
    <p v-if="order.payment_method==='credit'">
      商品は、出来上がり次第お送りさせて頂きますので、引続き宜しくお願い致します。
    </p>
    <p>
      「注文受付メールが届かない場合」<br>
      注文受付メールが届かない場合、ドメイン指定されている可能性があります。<br>
      「@chapeu.co.jp」「@chapeu.ciao.jp」を受信できるようにしてください。<br>
      ※「ezweb.ne.jp」や「au.com」等、auの携帯メールアドレスをご利用のお客様に、Chapeuシミュレーターからの注文受付メールが届かないというケースが確認されております。<br>
      おそらくですが、メールフィルターで、迷惑メールとして判断されてしまうことが原因だと思われます。<br>
      お手数ですが、受信リスト設定を行ってください。
    </p>
    <p>
      設定後、または「gmail.com」等のウェブメール（au以外のメールアドレス）にて「info@chapeu.ciao.jp」にメールをお送りください。<br>
      再度、注文受付メールをお送りさせていただきます。<br>
      お手数おかけして申し訳ありませんが、何卒宜しくお願い致します。<br>
      ※携帯のメールアドレスは各社の迷惑メール対策にかかり、注文受付メールが届かないというケースが確認されておりますので、「gmail.com」等のウェブメールのご利用をお勧めします。
    </p>

    <div class="footer">
      <div class="footer-container">
        <vk-button @click="$router.push({name:'category'})">TOPページへ</vk-button>
      </div>
    </div>

  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import axios from 'axios/dist/axios.min'
  import Loading from '../../service/loading';

  export default {
    name: 'done-paper',
    components: {Loading},
    data(){
      return {
        loading: false,
      }
    },
    computed: {
      ...mapGetters([
        'order',
      ]),
      cart_number(){
        return this.$store.state.cart.number;
      }
    },
    created (){
      if (this.order.payment_method === 'bank') {
        this.$store.commit('setLoading');
        this.loading = true;
        axios.post('/orders/add_stock_cart.json', {json:
            {
              order: this.$store.state.order,
              stock_cart: this.$store.state.stock_cart
            }
        })
          .then(response => {
            this.$store.commit('resetLoading');
            this.loading = false;
            this.$store.commit('setCartNumber', response.data.order.number);
            this.$store.commit('resetCartStock');
          });
      }
    }
  }
</script>

<style lang="scss" scoped>
  #done-paper{
    padding-bottom: 50px;
  }
  #done-paper p{
    margin: 10px 4px;
  }
  .footer {
    position: fixed;
    width: 100%;
    bottom: 0;
    color: #fff;
    background-color: #151d66;
    .footer-container {
      height: 36px;
      padding: 5px;
    }
  }

</style>
